(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mmt-holiday-dispatch"] && !Shopify.designMode) return;
  try {
    (() => {
    const initialiseHolidayNotice = () => {
      const notice = document.getElementById('mmt-holiday-dispatch');
      if (!notice || notice.dataset.bound === 'true') return;
      notice.dataset.bound = 'true';
      const cutoff = Number(notice.dataset.cutoff) * 1000;
      const end = Number(notice.dataset.end) * 1000;
      const summary = notice.querySelector('[data-holiday-summary]');
      if (!Number.isFinite(cutoff) || !Number.isFinite(end) || !summary) return;
      let interval;
      const refresh = () => {
        const now = Date.now();
        if (now >= end) {
          notice.hidden = true;
          window.clearInterval(interval);
          return;
        }
        summary.textContent = now < cutoff ? notice.dataset.before : notice.dataset.after;
      };
      refresh();
      if (!notice.hidden) interval = window.setInterval(refresh, 60000);
      window.addEventListener('pageshow', refresh);
      document.addEventListener('visibilitychange', refresh);
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialiseHolidayNotice, { once: true });
    } else {
      initialiseHolidayNotice();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
